

















































import { GET_ALL_LIMIT } from '@/constants'
import { Member } from '@/models'
import GroupMemberService from '@/services/GroupMemberService'
import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class ModalUpdateAuthorTopic extends Vue {
  @Prop({ default: 'update-author-topic' }) id!: string
  @Prop() private kickMemberId!: number

  memberList: Member[] = []
  selectedMember: string = ''

  async getMemberListWithoutMemberRole() {
    const response = await GroupMemberService.getAllMembersByGroupId({
      groupId: this.$route.params.groupId,
      page: 1,
      limit: GET_ALL_LIMIT,
      mention: this.kickMemberId !== -1 ? false : true,
      withoutMemberRole: true,
      kickMemberId: this.kickMemberId !== -1 ? this.kickMemberId : -1
    })
    if (response.status === 200) {
      const data = response.data.data
        .map((item: any) => new Member(item))
        .sort((a: Member, b: Member) => {
          return a.isAdmin === b.isAdmin ? 0 : a.isAdmin ? -1 : 1
        })
      this.memberList = data
    }
  }

  // trigger on close modal
  resetData() {
    this.selectedMember = ''
    this.memberList = []
  }

  closeModal() {
    this.$bvModal.hide(this.id)
  }

  onUpdateAuthorTopic() {
    if (this.selectedMember) {
      const userIdToTranfser = this.selectedMember
      this.$bvModal.hide(this.id)
      setTimeout(() => {
        this.$emit('onUpdateAuthorTopic', userIdToTranfser)
      }, 300)
    }
  }
}
